import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/searchExpedientes.php';

export default function searchExpedientes({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}